<template>
    <div class="salary">
        <b-form>
            <!-- Salary Details -->
            <h2>Bank Details - New Employees</h2>

            <template v-if="referer === 'IE'">
                <!-- IBAN Number -->
                <b-form-group
                        label="IBAN Number"
                >
                    <b-form-input
                            :value="form.IBAN"
                            @input="handleInput('IBAN', $event)"
                            :class="{
              'is-valid': !$v.form.IBAN.$error && form.IBAN,
              'is-invalid': $v.form.IBAN.$error
            }"
                    >

                    </b-form-input>

                </b-form-group>
                <!-- BIC Number -->
                <b-form-group
                        label="BIC Number"
                >
                    <b-form-input
                            :value="form.BIC"
                            @input="handleInput('BIC', $event)"
                            :class="{
              'is-valid': !$v.form.BIC.$error && form.BIC,
              'is-invalid': $v.form.BIC.$error
            }"
                    >

                    </b-form-input>

                </b-form-group>
            </template>

            <!-- Bank details -->
            <h3 class="mt-5">Bank/Building Society Details</h3>
            <!-- Bank/Building society name and address -->
            <b-form-group
                    label="Bank/Building Society Name"
            >
                <b-form-input
                        :value="form.bank"
                        @input="handleInput('bank', $event)"
                        :class="{
            'is-valid': !$v.form.bank.$error && form.bank,
            'is-invalid': $v.form.bank.$error
          }"
                >

                </b-form-input>
            </b-form-group>
            <!-- Account Number -->
            <b-form-group>
                <label style="font-weight: normal">
                    Account Number
                    <small>{{ referer === 'UK' ? '(minimum 8 numbers)' : '' }}</small>
                </label>
                <b-form-input
                        :value="form.accountNo"
                        @input="handleInput('accountNo', $event)"
                        :class="{
            'is-valid': !$v.form.accountNo.$error && form.accountNo,
            'is-invalid': $v.form.accountNo.$error
          }"
                >

                </b-form-input>
            </b-form-group>
            <!-- Sort Code -->
            <b-form-group>
                <label style="font-weight: normal">
                    Sort Code
                    <small>{{ referer === 'UK' ? '(6 numbers)' : '' }}</small>
                </label>

                <b-form-input
                        :value="form.sortCode"
                        @input="handleInput('sortCode', $event)"
                        :class="{
            'is-valid': !$v.form.sortCode.$error && form.sortCode,
            'is-invalid': $v.form.sortCode.$error
          }"
                >

                </b-form-input>
            </b-form-group>
            <!-- Building Society Account number reference -->
        </b-form>
    </div>
</template>

<script>
import {postCodeLookup} from '../../services/api'
import {mapActions, mapGetters, mapState} from 'vuex'
import {required, numeric, minLength, maxLength} from 'vuelidate/lib/validators'
import {selectPostcode, updateForm} from '../../helpers/index'

export default {
  computed: {
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getOnboardingForm: 'authStore/getOnboardingForm'
    }),
    ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.salaryForm}),
  },
  data() {
    return {
      formName: 'salaryForm',
      postcodeLookup: '',
      postcodeResult: '',
      startDate: null,
      referer: window.siteVar.referer,
    }
  },
  mounted() {
    this.$v.$touch()
  },
  updated() {
    // Pass validation status to vuex
    const validationData = {
      section: 'salary',
      status: !this.$v.form.$invalid
    }
    this.updateOnboardingCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      selectAddressAction: 'authStore/selectAddressAction',
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
      updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction'
    }),
    async ukPostcodeLookup() {
      const res = await postCodeLookup(this.postcodeLookup)
      this.postcodeResult = res.data.results
    },
    handlePostcode(address, addressOwner) {
      this.selectPostcode(address, addressOwner)
    },
    handleInput(input, e) {
      this.updateForm(input, e)
    },
    selectPostcode,
    updateForm
  },
  validations() {
    if (window.siteVar.referer === 'UK') {
      return {
        form: {
          bank: {
            required: required
          },
          accountNo: {
            required,
            numeric,
            minLength: minLength(8),
          },
          sortCode: {
            required,
            numeric,
            minLength: minLength(6),
            maxLength: maxLength(6),
          },
        }
      }
    } else {
      return {
        form: {
          bank: {
            required: required
          },
          accountNo: {
            required: required
          },
          sortCode: {
            required: required
          },
          IBAN: {
            required: required
          },
          BIC: {
            required: required
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.postcode-lookup-input {
    position: relative;
}

.postcode-lookup {
    position: relative;
}

.postcode-dropdown {
    background-color: #fff;
    position: absolute;
    width: 100% !important;
    top: 40px !important;
    max-height: 200px;
    z-index: 10;
    border: 1px solid #4da3ff;
    overflow: auto;
}

@media only screen and (min-width: 992px) {
    .postcode-dropdown {
        right: 0;
        top: 50px;
        width: 70%;
    }
}

.postcode-dropdown ul {
    list-style: none;
    padding: 0;
}

.postcode-dropdown li {
    padding: 10px;
}

.postcode-result {
    transition: all .3s ease;
}

.postcode-result:hover {
    cursor: pointer;
    background-color: #4da3ff;
}

.manual-address {
    display: flex;
    justify-content: center;
}
</style>
